// extracted by mini-css-extract-plugin
export default {"fullWidthRow":"Announcements_fullWidthRow__ZVWiZ","searchPanelRow":"Announcements_searchPanelRow__qSkmW","fullWidthCarousel":"Announcements_fullWidthCarousel__nCXmy"};